import React from "react"

const WarningIcon = ({ size, color = "currentColor" }) => {
	return (
        <svg height={size} viewBox="0 0 512 512.923" width={size} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M433.348 512.922H80.449A80 80 0 0 1 8.9 397.164L185.331 44.25C198.875 17.133 226.586 0 256.898 0s58.024 17.133 71.567 44.25l176.433 352.914a80 80 0 0 1-71.55 115.758zm0 0" fill={color}/>
            <g fill="white">
                <path d="M256.898 128.203c8.836 0 16 7.164 16 16v192c0 8.836-7.164 16-16 16s-16-7.164-16-16v-192c0-8.836 7.165-16 16-16zM240.898 384.203h32v32h-32zm0 0"/>
            </g>
        </svg>
	)
}

export default WarningIcon
